// extracted by mini-css-extract-plugin
export default {"container":"PortfolioValue_container__rDPiu","amount":"PortfolioValue_amount__NdSQ-","label":"PortfolioValue_label__p+rdS"};